/**
 * Location Reducer
 */
import {
    GET_LOCATION,
    GET_LOCATION_FAILURE,
    GET_LOCATION_SUCCESS,
    GET_ALL_LOCATIONS,
    GET_ALL_LOCATIONS_FAILURE,
    GET_ALL_LOCATIONS_SUCCESS,
    ADD_LOCATION,
    ADD_LOCATION_SUCCESS,
    ADD_LOCATION_FAILURE,
    EDIT_LOCATION,
    EDIT_LOCATION_SUCCESS,
    EDIT_LOCATION_FAILURE,
    REMOVE_LOCATION,
    REMOVE_SUCCESS,
    REMOVE_FAILURE,
    TOGGLE_HIDDEN_LOCATION,
    TOGGLE_HIDDEN_LOCATION_SUCCESS,
    TOGGLE_HIDDEN_LOCATION_FAILURE,
    CONFIRM_ERROR_DELETE_POPUP,
    LOAD_MAP,
    INIT_STATE_LOCATION,
    CLEAR_LOCATION_CACHE
} from 'Actions/types';



// initial state
const INIT_STATE = {
    allLocation: null,        // For getLocation (basic locations for dropdowns/other pages)
    manageLocation: null,     // For getAllLocations (full location management on locations page)
    errorsServer: null,
    remove_success: null,
    errorsServerDelete: null,
    loadMap: false,
    open: false,
    addNewModal: false,
    getLocationSuccess: false,
    onDeleting: false,
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LOCATION:
            return { ...state, loading: true };

        case GET_LOCATION_SUCCESS:
            return { ...state, allLocation: action.payload.data, loading: false };

        case GET_ALL_LOCATIONS:
            return { ...state, loading: true };

        case GET_ALL_LOCATIONS_SUCCESS:
            return { ...state, manageLocation: action.payload.data, addNewModal: false, getLocationSuccess: true, open: false, loading: false };

        case GET_ALL_LOCATIONS_FAILURE:
            return { ...state, errorsServer: action.payload.response.data, loading: false };

        case REMOVE_LOCATION:
            return { ...state, payload: action, errorsServerDelete: null, onDeleting: true };

        case GET_LOCATION_FAILURE:
            return { ...state, errorsServer: action.payload.response.data, loading: false };

        case REMOVE_SUCCESS:
            return { ...state, onDeleting: false };

        case REMOVE_FAILURE:
            return { ...state, errorsServerDelete: action.payload.response.data, onDeleting: false };

        case EDIT_LOCATION:
            return { ...state,loading:true, payload: action, errorsServer: null };

        case EDIT_LOCATION_SUCCESS    :
            return {...state, loading: false}

        case EDIT_LOCATION_FAILURE:
            return { ...state,loading: false, errorsServer: action.payload.response.data };

        case TOGGLE_HIDDEN_LOCATION:
            return { ...state, loading: true, errorsServer: null };

        case TOGGLE_HIDDEN_LOCATION_SUCCESS:
            return { ...state, loading: false };

        case TOGGLE_HIDDEN_LOCATION_FAILURE:
            return { ...state, loading: false, errorsServer: action.payload.response.data };

        case ADD_LOCATION:
            return { ...state,loading:true, payload: action, errorsServer: null };

        case ADD_LOCATION_SUCCESS:
            return {...state, loading: false}
        
        case ADD_LOCATION_FAILURE:
            return { ...state,loading: false, errorsServer: action.payload.response.data };

        case CONFIRM_ERROR_DELETE_POPUP:
            return { ...state, errorsServerDelete: null };

        case LOAD_MAP:
            return { ...state, loadMap: true };

        case INIT_STATE_LOCATION:
            return { ...state, getLocationSuccess: false };

        case CLEAR_LOCATION_CACHE:
            return { ...state, manageLocation: null };
            
        default: return { ...state };
    }
};
